export default async function asyncMethodWithRetry(methodAsync: () => Promise<any>, maxAttempts: number = 30) {
  let attempt = 1
  while (attempt <= maxAttempts) {
    try {
      return await methodAsync()
    } catch (error) {
      if (attempt === maxAttempts) {
        throw error
      } else if (error && error.status == 404) {
        await new Promise((resolve) => setTimeout(resolve, 500))
        attempt++
      } else {
        throw error
      }
    }
  }
}
